<div class="sidenav">
    <mat-nav-list>
        <mat-list-item class="nav-toggle" (click)="isExpanded = !isExpanded">
            <mat-icon>{{ isExpanded ? 'chevron_left' : 'chevron_right' }}</mat-icon>
        </mat-list-item>

        <mat-list-item *ngFor="let item of menuItems" [routerLink]="item.link" [routerLinkActive]="'active'">
            <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
            <a matLine *ngIf="isExpanded">{{ item.label | translate }}</a>
        </mat-list-item>
    </mat-nav-list>

    <div class="eu-banner" *ngIf="isExpanded">
        <img src="./../assets/images/logos/accept-banner.png" alt="banner" width="60px">
        <p class="eu-banner-text">{{ 'app.eu-banner' | translate }}</p>
        <p><b>© 2021 {{ 'app.all-right-reserved' | translate }}</b></p>
    </div>
</div>
